<template>
  <div class="binding">
    <weui-group :notitle="true">
      <weui-cell tips="为你提供以下预约信息">
        <router-link role="button" class="btn_guide" :to="{ name: ROUTE_GUIDE }">身体觉醒教练端</router-link>
      </weui-cell>
    </weui-group>
    <weui-group :tips="TEXT_SLOGAN" />
    <weui-group :tips="`${formatDate(date)}可供预约课程的时段${ bound ? '' : '，您仅能查看不能预约'}`" />
    <weui-group>
      <weui-cell v-for="time in times" :key="time" @click="selectTime(time)">
        <p :class="{ 'cell-text': true, bound }">{{ formatTime(time) }}</p>
      </weui-cell>
      <weui-cell v-if="!bound">
        <router-link role="button" class="cell-button" style="text-align: center;" :to="{ name: ROUTE_SHARE_BINDING, params: { hash: this.hash } }" replace>立刻绑定{{ coach && coach.name }}教练</router-link>
      </weui-cell>
    </weui-group>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import weui from 'weui.js';

import { WeuiGroup, WeuiCell } from '@/components/weui';
import { TEXT_SLOGAN } from '@/constants/text';
import share from '@/api/share';
import { ROUTE_GUIDE, ROUTE_SHARE_BINDING, ROUTE_COURSE_CREATE_CREATED } from '@/router/names';
import { COURSE_DRAFT_INITIALIZE, COURSE_DRAFT_FILL, CREATE_DRAFT_COURSE } from '@/store/course/types';
import mixinFormatters from '@/mixins/formatters';
import datetimeUtils from '@/utils/datetime';

const { mapState: mapWechatState } = createNamespacedHelpers('wechat');
const { mapState: mapCourseState, mapActions: mapCourseActions, mapMutations: mapCourseMutations } = createNamespacedHelpers('course');

export default {
    props: {
        hash: {
            type: String,
            required: true,
        },
        coach: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            TEXT_SLOGAN,
            ROUTE_GUIDE,
            ROUTE_SHARE_BINDING,
            date: null,
            times: [],
        };
    },
    computed: {
        ...mapCourseState({
            draft: state => state.draft,
            created: state => state.created,
        }),
        ...mapWechatState({
            trainer: state => state.trainer,
        }),
        bound() {
            return !!(this.trainer && this.trainer.id);
        },
    },
    mounted() {
        share.getTimes(this.hash)
            .then((resp) => {
                this.date = resp.date;
                this.times = resp.available_times;
            });
    },
    methods: {
        ...mapCourseMutations({
            initializeDraft: COURSE_DRAFT_INITIALIZE,
            fillDraft: COURSE_DRAFT_FILL,
        }),
        ...mapCourseActions({
            createDraft: CREATE_DRAFT_COURSE,
        }),
        selectTime(time) {
            if (!this.bound) {
                return;
            }
            const message = `确认申请${this.formatDate(this.date)}${this.formatTime(time)}的课程吗？`;
            weui.confirm(message, () => {
                this.initializeDraft();
                this.fillDraft({
                    date: this.date,
                    start_time: time,
                    end_time: datetimeUtils.getNextHour(time),
                });
                this.createDraft(this.draft)
                    .then(() => {
                        this.$router.replace({
                            name: ROUTE_COURSE_CREATE_CREATED,
                            params: {
                                id: this.created.id,
                            },
                        });
                    });
            });
        },
    },
    mixins: [
        mixinFormatters,
    ],
    components: {
        WeuiGroup,
        WeuiCell,
    },
};
</script>

<style lang="scss" scoped>
@import './../../assets/scss/variables';

.cell-text {
    text-align: center;

    &:not(.bound) {
      color: $cell-text-color;
    }
}

.btn_guide {
    color: $blue;
}
</style>



// WEBPACK FOOTER //
// src/components/share/Times.vue